module.exports = __webpack_public_path__ + "5f5a737e1c151d1041925a4a7c6dd03e.woff";